<template>
  <div>
    <el-row class="title-table" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">자원 구분</div>
        <div class="setting-addel mr-r4">
          <el-button size="mini" @click="clickAddRsctypeButton"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" @click="clickDeleteRsctypeButton" :disabled="checkedRows.length == 0"><i class="fas fa-minus"></i></el-button>
        </div>
        <el-select class="mr-r4" v-model="managetypeId" style="width:170px;">
          <el-option v-for="item in managetypeList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
        </el-select>
        <el-select v-show="managetypeId=='NMS'||managetypeId=='FMS'||managetypeId=='DBMS'||managetypeId=='VMS'" v-model="managetypeKey" style="width:140px;">
          <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.managetypeKeyName" :value="item.managetypeKey"></el-option>
        </el-select>
      </div>
      <div class="vertical-center-box">
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper class="mr-b20" :data="rsctypeTableData" :columns="rsctypeTableColumn" :column-default="columnDefault" row-class-name="c-dblclick" ref="rsctypeTable" @selection-change="changeCheckedRow"
      @row-dblclick="dblclickRow" :pagination="false" style="width:100%;" :show-custom-header="true" :show-search-tool="showSearchTool">
      <template slot-scope="scope" slot="look-slot">
        <i class="el-icon-search" @click.stop="clickLookButton(scope.row)" style="cursor:pointer"></i>
      </template>
    </el-table-wrapper>
    <w-add-rsctype-popup ref="addRsctypePopup" :managetype-id="managetypeId" :managetype-key="managetypeKey" :orderby-index="orderbyIndex" @re-load="loadData"></w-add-rsctype-popup>
    <w-update-rsctype-popup ref="updateRsctypePopup" :managetype-id="managetypeId" :managetype-key="managetypeKey" :update-row="updateRow" @re-load="loadData"></w-update-rsctype-popup>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import ManagetypeKeyAPI from '@/api/model/managetype-key';
import RscSettingsAPI from '@/api/settings/common/rsc-settings';
import WAddRsctypePopup from '../popup/AddRsctypePopup';
import WUpdateRsctypePopup from '../popup/UpdateRsctypePopup';

export default {
  name: 'WRsctypeTable',
  components: {
    WAddRsctypePopup,
    WUpdateRsctypePopup,
  },
  props: {
    managetypeList: Array,
  },
  watch: {
    /**
     * 관리 구분 바인딩 시 첫번째 관리 구분이 자동으로 선택되도록 한다.
     * @author Ju
     * @param  {[type]} to [description]
     */
    managetypeList: {
      immediate: true,
      handler(to) {
        if (!isEmpty(to)) {
          this.managetypeId = this.managetypeList[0].managetypeId;
        }
      },
    },
    managetypeId: {
      immediate: true,
      handler(value) {
        this.selectedRsctypeRow = null;
        if (!isNil(value)) {
          ManagetypeKeyAPI.getDisplayedManagetypeKeyList(value).then((response) => {
            if (response.data.success) {
              if ((isEqual(value, 'NMS') || isEqual(value, 'FMS') || isEqual(value, 'DBMS') || isEqual(value, 'VMS'))) {
                this.managetypeKeyList = response.data.data;
                this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
              } else {
                this.managetypeKey = '_';
              }
              this.managetypeIdKey = `${value}.${this.managetypeKey}`;
            } else {
              this.managetypeKeyList = [];
              this.managetypeKey = null;
            }
          }).catch(() => {
            this.managetypeKeyList = [];
            this.managetypeKey = null;
          });
        }
      },
    },
    managetypeKey: {
      immediate: true,
      handler(value) {
        const managetypeId = this.managetypeId;
        this.managetypeIdKey = `${managetypeId}.${value}`;
      },
    },
    managetypeIdKey: {
      immediate: true,
      handler(value) {
        this.selectedRsctypeRow = null;
        if (!isNil(value)) {
          if (!isNil(this.managetypeId) && !isNil(this.managetypeKey)) {
            this.loadData();
          }
        }
      },
    },
  },
  data() {
    return {
      managetypeId: null,
      managetypeKey: null,
      managetypeIdKey: null,
      orderbyIndex: 1,
      managetypeKeyList: [],
      selectedRsctypeRow: null,
      updateRow: null,
      checkedRows: [],
      rsctypeTableData: [],
      rsctypeTableOriginData: [],
      columnDefault,
      showSearchTool: false,
      rsctypeTableColumn: [
        {
          type: 'selection',
          align: 'center',
        },
        // {
        //   prop: 'applystatFlag',
        //   label: '적용',
        //   headerAlign: 'center',
        //   width: 80,
        //   align: 'center',
        //   scopedSlot: 'switch-slot',
        // },
        {
          prop: 'rsctypeId',
          label: '자원구분 ID',
          searchable: true,
        },
        {
          prop: 'rsctypeName',
          label: '자원구분명',
          searchable: true,
        },
        {
          align: 'center',
          width: 80,
          scopedSlot: 'look-slot',
        },
      ],
    };
  },
  methods: {
    loadData() {
      const managetypeId = this.managetypeId;
      const managetypeKey = this.managetypeKey;
      RscSettingsAPI.getRsctypeList({ managetypeId, managetypeKey }).then((response) => {
        this.rsctypeTableData = cloneDeep(response.data.data);
        this.rsctypeTableOriginData = cloneDeep(response.data.data);
        this.$nextTick(() => {
          let row = this.selectedRsctypeRow;
          if (isNil(row)) {
            row = this.rsctypeTableData[0];
          }
          this.clickLookButton(row);
        });
      });
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    clickAddRsctypeButton() {
      if (!isNil(this.rsctypeTableData)) {
        if (this.rsctypeTableData.length > 0) {
          this.orderbyIndex = this.rsctypeTableData[this.rsctypeTableData.length - 1].orderbyIndex + 1;
        }
      }
      this.$refs.addRsctypePopup.$refs.slidingPopup.visible = true;
    },
    clickDeleteRsctypeButton() {
      const action = msgUtil.action.DELETE;
      const target = '자원 구분';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        RscSettingsAPI.deleteRsctypes(this.checkedRows).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            if (this.checkedRows.indexOf(this.selectedRsctypeRow) >= 0) {
              this.selectedRsctypeRow = null;
            }
            this.checkedRows = [];
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    dblclickRow(row) {
      this.updateRow = cloneDeep(row);
      this.$refs.updateRsctypePopup.$refs.slidingPopup.visible = true;
    },
    clickLookButton(row) {
      this.selectedRsctypeRow = row;
      this.$emit('set-rsctype', this.selectedRsctypeRow);
    },
  },
};
</script>

<style>
.title-table {
  //padding: 10px 0px 10px 0px;
  padding-bottom: 10px
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/RscSettings/components/RsctypeTable.vue